



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
/**
 * Required:
 * stock_quantity
 * stock_status_id
 * price
 * date_available
 * weight?
 * weight_class_id
 * length?
 * width?
 * height?
 * length_class_id?
 * quantity_per_lot?
 * public
 *
 * name
 * variantname
 * description
 * metaTitle/Description/Keyword
 * Image / ImageDescription
 * product_options?
 * product_related?
 * product_tag?
 * variants
 */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { createProduct, getProductForEdit, getTagList, splitVariants, updateProduct } from '../api/products'
import Tinymce from '@/components/Tinymce/index.vue'
import snackbar from '@/components/snackbar.vue'
import store from '../store'
import axios from 'axios'
import { deepCopy } from '@/components/deepCopy'
import { filter } from 'vue/types/umd'
interface DBProduct {
  product_id: number // negative for non-existing products
  product_number?: string
  stock_quantity: number
  stock_status_id: number
  price: number
  tax_id: number
  date_available: Date
  weight?: number
  weight_class_id?: number
  length?: number
  width?: number
  height?: number
  length_class_id?: number
  quantity_per_lot: number
  date_added?: Date
  date_modified?: Date
  digital: boolean
  manufacturing_price?: number
  viewed: number
  public: boolean
}
interface DBProductDescription {
  language_id: number
  name: string
  variantname: string
  description: string
  metaTitle: string
  metaDescription: string
  metaKeyword: string
  automaticSEO: boolean
}
interface DBProductImage {
  product_image_id: number | null
  path: string
  path_small: string | null
  sort_order: number
  date_added: Date
}
interface DBProductImageDescription {
  language_id: number
  description: string
  name: string
}
interface ProductImage extends DBProductImage {
  text: DBProductImageDescription[]
  previewBeforeUpload: ImageData | null
  file?: any
  'text.translated'?: DBProductImageDescription
}
interface Tag {
  id: number
  name: string
  language_id: number
}
interface ShopFile {
  id: number
  name: string
  extension: string
  path?: string // for already uploaded files
  file?: any // for uploading
  size: number
  viewed: number
  date_added: Date
  date_modified: Date
  sort_order: number
}
// type translatedProductDescription = () => DBProductDescription
interface Product extends DBProduct {
  oldPrice?: number
  description: DBProductDescription[]
  images: ProductImage[]
  tags: Tag[]
  previewSourceList: (string | ImageData)[] | null
  sort_order: number
  category?: number
  filesPublic: ShopFile[]
  removedImages: number[]
  removedPublicFiles: number[]
  // 'description.translated'?: translatedProductDescription
}

interface StockStatusItem {
  id: string
  name: string
  disabled: boolean
}

@Component({
  name: 'Product',
  components: { Tinymce, snackbar }
})
export default class extends Vue {
  private language_id = 2
  /**
   * To remove unsaved changes
   */
  variantsUnedited: Array<Product> = []
  /**
   * This holds all variants and also unapplied changes
   */
  private variants: Product[] = []
  activeVariant: Product | null = null
  activeImage: ProductImage | null = null
  private draggingImage = false
  private draggingFilePublic = false
  private formData: FormData | null = null
  private uploadFieldName = 'images[]'
  private uploadFilesPublic = 'filesPublic[]'

  variantSorterDialog = false
  // TODO: get taxrates from DB
  private taxrates = [
    {
      name: '19%',
      id: 1
    },
    {
      name: '7%',
      id: 2
    },
    {
      name: '0%',
      id: 3
    }
  ]
  // private addVariantItems =
  get addVariantItems() {
    return [
      {
        name: 'Neu aus aktueller Variante',
        action: () => {
          this.addProductTemplateFromExisting()
        }
      },
      {
        name: 'Neue leere Variante',
        action: () => {
          this.addProductTemplate()
        }
      },
      {
        name: 'Varianten trennen',
        action: () => {
          this.openVariantSorter()
        },
        disabled: this.variants.length < 2
      }
    ]
  }
  variantSplitter: Product[][] = []

  get variantSplitterNew() {
    if (this.variantSplitter.length > 1) {
      return this.variantSplitter.slice(1)
    } else {
      return null
    }
  }
  openVariantSorter() {
    this.variantSplitter = []
    const copy = []
    for (let index = 0; index < this.variantsUnedited.length; index++) {
      const element = this.variantsUnedited[index]
      copy.push(deepCopy(this.variantsUnedited[index]))
    }
    this.variantSplitter.push(copy)
    this.variantSorterDialog = true
  }
  closeVariantSorter() {
    this.variantSorterDialog = false
  }
  async saveVariantSorter() {
    const groups = this.variantSplitter.map(arr => {
      const prods = arr.map(prod => {
        return prod.product_id
      })
      return prods
    })
    try {
      const answer = await splitVariants(groups)
      // refresh page
      window.location.reload()
      this.variantSorterDialog = false
    } catch (error) {
      console.error(error)
    }
  }
  onDropCreateGroup(event) {
    event.preventDefault()

    const a: Product[] = []
    a.push(this.draggedVariant)
    this.variantSplitter.push(a)
    const ind = this.variantSplitter[this.draggedVariantGroup].findIndex((val, ind) => {
      return val.product_id == this.draggedVariant.product_id
    })
    this.variantSplitter[this.draggedVariantGroup].splice(ind, 1)
    for (let index = this.variantSplitter.length - 1; index >= 0; index--) {
      const element = this.variantSplitter[index]
      if (element.length == 0) {
        this.variantSplitter.splice(index, 1)
      }
    }
  }
  onDropInGroup(event, groupIndex) {
    event.preventDefault()
    if (groupIndex != this.draggedVariantGroup) {
      this.variantSplitter[groupIndex].push(this.draggedVariant)
      const ind = this.variantSplitter[this.draggedVariantGroup].findIndex((val, ind) => {
        return val.product_id == this.draggedVariant.product_id
      })
      this.variantSplitter[this.draggedVariantGroup].splice(ind, 1)
      for (let index = this.variantSplitter.length - 1; index >= 0; index--) {
        const element = this.variantSplitter[index]
        if (element.length == 0) {
          this.variantSplitter.splice(index, 1)
        }
      }
    }
  }
  allowDrop(event) {
    event.preventDefault()
  }
  draggedVariant: Product = null
  draggedVariantGroup = null
  dragStart(variant: Product, groupIndex) {
    console.log(groupIndex)
    this.draggedVariant = variant
    this.draggedVariantGroup = groupIndex
    // event.dataTransfer.setData('text', event.target.id)
  }

  private SEOVisible = false
  get SEODropdownState() {
    if (this.SEOVisible) {
      return 'mdi-chevron-up'
    } else {
      return 'mdi-chevron-down'
    }
  }
  switchSEO() {
    this.SEOVisible = !this.SEOVisible
  }
  get categoryList() {
    function filterCategories(array) {
      let ret = []
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        if (element.children.length == 0) {
          ret.push(element)
        } else {
          ret = ret.concat(filterCategories(element.children))
        }
      }
      return ret
    }
    const filtered = filterCategories(this.$store.state.categories)
    return filtered.map(category => {
      return { name: category.name, id: category.id }
    })
  }
  //LATER: maybe replace it with
  // https://vuetifyjs.com/en/components/menus/#custom-transitions
  // menu as popover,
  // with clickable images to find the bottom category.

  private tinymceActive = true

  private tagSearch = null
  private formValid = true
  automaticProductNumber = this.$store.state.automaticProductNumber

  private nameRules = [
    (v: any) => !!v || 'Artikelname ist erforderlich',
    (v: any) => (v && v.length >= 6) || 'Der Artikelname muss mindestens aus 6 Zeichen bestehen'
  ]
  private variantNameRules = []
  private productNumberRules = []
  private descriptionRules = []
  private priceRules = [
    (v: any) => !!v || 'Preis ist erforderlich',
    (v: any) => (v && v > 0) || 'Preis darf nicht 0 sein.'
  ]
  private metaTitleRules = []
  private metaDescriptionRules = []

  private showDatePicker = false
  private datePicker = new Date().toISOString().substr(0, 10)

  private stock_status_items: StockStatusItem[] = [
    {
      id: '1',
      name: 'Auf Lager',
      disabled: false
    },
    {
      id: '2',
      name: 'Nicht verfügbar',
      disabled: false
    },
    {
      id: '3',
      name: '2-3 Tage',
      disabled: false
    },
    {
      id: '4',
      name: 'Vorbestellung',
      disabled: false
    }
  ]

  private weightClasses = [
    {
      id: 2,
      name: 'Kg'
    },
    {
      id: 1,
      name: 'g'
    }
  ]
  private lengthClasses = [
    {
      id: 1,
      name: 'mm'
    },
    {
      id: 2,
      name: 'cm'
    },
    {
      id: 3,
      name: 'm'
    }
  ]

  // @Watch('language_id')
  // OnLanguageSwitched(lang: number) {
  //   if (this.activeVariant != null) {
  //     for (const item of this.activeVariant.description) {
  //       if (item.language_id === this.language_id) {
  //         this.activeVariant['description.translated'] = item
  //       }
  //     }
  //   }
  // }
  private nettoPrice = 0
  private loading = true

  @Watch('datePicker')
  onAvailableChanged(value: string) {
    this.activeVariant.date_available = new Date(value)
  }
  @Watch('activeVariant.price')
  OnPriceChanged(value: number) {
    this.nettoPrice = parseFloat((Math.round((value / 1.19) * 100) / 100).toFixed(2))
  }
  private selectedStockOption: string | null = '2'
  @Watch('selectedStockOption', { deep: true })
  OnStockOptionChanged(val: string, oldVal: string) {
    if (this.activeVariant != null) {
      this.activeVariant.stock_status_id = parseInt(val)
    }
  }
  @Watch('activeVariant.stock_quantity', { deep: true, immediate: false })
  OnStockQuantityChanged(value: number, oldValue: number) {
    if (value == 0) {
      if (this.activeVariant != null && this.selectedStockOption != null && this.selectedStockOption == '1') {
        this.selectedStockOption = this.stock_status_items[3].id
      }
      this.stock_status_items[0].disabled = true
    } else {
      this.stock_status_items.forEach(item => (item.disabled = false))
    }
  }

  get currentLanguageDescription() {
    if (this.activeVariant == null) {
      return null
    }
    return this.getLanguageItem(this.activeVariant.description)
  }
  // TODO: how to watch a function? for different languages
  @Watch('currentLanguageDescription.name')
  OnNameChanged(newName: string, oldName: string) {
    if (this.getLanguageItem(this.activeVariant.description).automaticSEO) {
      this.applyAutomaticSEO()
    }
  }

  @Watch('currentLanguageDescription.description')
  OnDescriptionChanged(newName: string, oldName: string) {
    if (this.getLanguageItem(this.activeVariant.description).automaticSEO) {
      this.applyAutomaticSEO()
    }
  }

  automaticSEO = this.$store.state.automaticSEO
  @Watch('automaticSEO', { deep: true, immediate: false })
  OnAutomaticSEOChanged(state: boolean, oldState: boolean) {
    this.getLanguageItem(this.activeVariant.description).automaticSEO = state
    if (state) {
      this.applyAutomaticSEO()
    }
  }
  applyAutomaticSEO() {
    this.getLanguageItem(this.activeVariant.description).metaTitle = this.computedSEOTitle
    this.getLanguageItem(this.activeVariant.description).metaDescription = this.computedSEODescription
  }
  get computedSEOTitle() {
    return (
      (this.getLanguageItem(this.activeVariant.description).name as string).substr(
        0,
        69 - this.$store.state.automaticSEOTitleAppend.length
      ) +
      ' ' +
      this.$store.state.automaticSEOTitleAppend
    )
  }
  // TODO: remove more HTML Tags from copied Description
  get computedSEODescription() {
    let str = this.getLanguageItem(this.activeVariant.description).description as string
    str = str.replaceAll('<p>', '')
    str = str.replaceAll('</p>', '')
    str += ',' + this.getLanguageItem(this.activeVariant.description).name
    str += ',' + this.getLanguageItem(this.activeVariant.description).variantname
    return (
      str.substr(0, 159 - this.$store.state.automaticSEODescriptionAppend.length) +
      ',' +
      this.$store.state.automaticSEODescriptionAppend
    )
  }

  get IsExistingProduct() {
    return this.activeVariant.date_added !== undefined
  }
  /**
   * Completely new product, without any variants.
   */
  get IsNewProduct() {
    return this.$route.params.id === undefined
  }

  private onImageUpload(e: any) {
    const files = e.target.files || e.dataTransfer.files
    if (!files.length) return
    files.forEach((file: any) => {
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
        this.addImagePreview(file)
      } else {
        // one or more files are not images
        // TODO: decide what to do. maybe shake something red?
      }
    })
  }
  private onFilePublicUpload(e: any) {
    const files = e.target.files || e.dataTransfer.files
    if (!files.length) return
    files.forEach((file: any) => {
      this.readFile(file)
    })
  }
  private removePublicFile(id: number) {
    for (let index = 0; index < this.activeVariant.filesPublic.length; index++) {
      const file = this.activeVariant.filesPublic[index]
      if (file.id == id) {
        if (file.id >= 0) {
          // mark for removal
          this.activeVariant.removedPublicFiles.push(file.id)
        }
        this.activeVariant.filesPublic.splice(index, 1)
        // re-index all other not yet created files, so that adding a new file has no chance of leading to a double used index
        for (let reIndex = 0; reIndex < this.activeVariant.filesPublic.length; reIndex++) {
          const element = this.activeVariant.filesPublic[reIndex]
          if (element.path == null) {
            element.id = -(reIndex + 1)
          }
        }
        break
      }
    }
  }

  async created() {
    if (this.$route.params.id != undefined) {
      //page: edit
      const answer = await getProductForEdit(this.$route.params.id)
      console.log(answer)

      answer.data.forEach(product => {
        this.addServerProduct(product)
      })

      // set the active variant
      for (let index = 0; index < this.variants.length; index++) {
        const variant = this.variants[index]
        if (variant.product_id == parseInt(this.$route.params.id)) {
          this.switchVariant(variant.product_id)
        }
      }
      // /**
      //  * do not automatically change SEO when loading a product
      //  */
      // if (this.IsExistingProduct) {
      //   this.automaticSEO = false
      // }
      // set stock
      this.selectedStockOption = this.activeVariant?.stock_status_id.toString()
    } else {
      // page: new
      this.addProductTemplate()
      this.activeVariant = this.variants[0]
    }
    this.$store.dispatch('refreshTags')
    this.$store.dispatch('refreshCategories')

    this.loading = false
  }

  get orderedImages() {
    if (this.activeVariant == null) return []
    return this.activeVariant!.images.sort((a, b) => {
      if (a.sort_order < b.sort_order) return -1
      else if (a.sort_order == b.sort_order) return 0
      else return 1
    })
  }
  private getLanguageItem(itemList: any) {
    for (const item of itemList) {
      if (item.language_id === this.language_id) {
        return item
      }
    }
    return null
  }

  private isUploading = false
  private meldung = ''
  private snackbar = false

  switchVariant(id: number) {
    let i = 0
    for (i; i < this.variants.length; i++) {
      if (this.variants[i].product_id === id) {
        console.log('new variant: ' + this.variants[i].product_id)
        this.activeImage = null
        this.activeVariant = this.variants[i]
        if (this.activeVariant.previewSourceList != null && this.activeVariant.previewSourceList.length > 0) {
          this.activeImage = this.activeVariant.images[0]
        } else if (this.activeVariant.images.length != 0) {
          this.activeImage = this.activeVariant.images[0]
        }

        break
      }
    }
  }

  private touchUpUpdate(product: any): any {
    if (product.price !== undefined) {
      product.price = parseFloat(product.price.toString().replace(',', '.'))
    }
    // /**
    //  * Remove attached previews
    //  */
    if (product.images != null) {
      for (const iterator of product.images) {
        if (iterator.previewBeforeUpload !== undefined) {
          iterator.previewBeforeUpload = null
        }
      }
    }

    // product.previewSourceList = null
    return product
  }
  private touchUpData(product: Product) {
    // TODO: replace with JS edition later
    product.price = parseFloat(product.price.toString().replace(',', '.'))
    // since the radio buttons save the values as string, we need to convert them.
    // if (product.weight_class_id !== undefined) {
    //   product.weight_class_id = parseFloat(product.weight_class_id as string)
    // }
    // if (product.stock_status_id !== undefined) {
    //   product.stock_status_id = parseInt(product.stock_status_id as string)
    // }
    // if (product.length_class_id !== undefined) {
    //   product.length_class_id = parseInt(product.length_class_id as string)
    // }
    if (product.date_available === undefined) {
      product.date_available = new Date()
    }
    /**
     * Remove attached previews
     */
    for (const iterator of product.images) {
      if (iterator.previewBeforeUpload !== undefined) {
        iterator.previewBeforeUpload = null
      }
    }
    product.previewSourceList = null
    return product
  }
  private sortImages(variant: Product) {
    if (variant.images.length >= 2) {
      variant.images.sort((a, b) => {
        if (a.sort_order < b.sort_order) return -1
        if (a.sort_order > b.sort_order) return 1
        return 0
      })
    }
  }

  private removeCurrentImage() {
    // TODO
    if (this.activeImage.product_image_id != null) {
      // removing existing image
      const removedID = this.activeImage.product_image_id
      for (let index = 0; index < this.activeVariant.images.length; index++) {
        const element = this.activeVariant.images[index]
        if (element.path == this.activeImage.path) {
          this.activeVariant.images.splice(index, 1)
          if (this.activeVariant.images.length > 0) {
            this.activeImage = this.activeVariant.images[0]
          } else {
            this.activeImage = null
          }
          break
        }
      }
      // tell server we removed this image
      this.activeVariant.removedImages.push(removedID)
    } else {
      // removing non-uploaded image
      for (let index = 0; index < this.activeVariant.images.length; index++) {
        const element = this.activeVariant.images[index]
        if (element.path == this.activeImage.path) {
          this.activeVariant.images.splice(index, 1)
          if (this.activeVariant.images.length > 0) {
            this.activeImage = this.activeVariant.images[0]
          } else {
            this.activeImage = null
          }
          break
        }
      }
    }
  }
  /**
   * gathers relevant information and uploads the data of a product-to-be to the server
   */
  private async validateAndSendProduct() {
    // let description = this.activeVariant!.description;
    // let test = this.getLanguageItem(description).name;
    // this.autoTranslate(test);
    const formValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!formValid) {
      return false
    }
    console.log('processing upload data')
    if (this.activeVariant == null) {
      throw new Error('activeVariant is not defined!')
    }
    // touch up
    const product = this.touchUpData(this.activeVariant)
    const newImageFiles: any[] = []
    const existingImageFiles: any[] = []
    this.sortImages(this.activeVariant)

    // upload images, but only new ones
    // connect existing ones!
    for (let index = 0; index < product.images.length; index++) {
      const element = product.images[index]
      if (element.file != null) {
        newImageFiles.push(element.file)
      } else {
        // connect existing images
        existingImageFiles.push({ image_id: element.product_image_id, sort_order: element.sort_order })
      }
    }
    this.formData = new FormData()
    if (newImageFiles.length > 0) {
      Array.from(Array(newImageFiles.length).keys()).map(x => {
        this.formData.append('newImages', newImageFiles[x], newImageFiles[x].name)
      })
    }
    if (this.activeVariant.filesPublic.length > 0) {
      Array.from(Array(this.activeVariant.filesPublic.length).keys()).map(x => {
        this.formData.append(
          'filesPublic',
          this.activeVariant.filesPublic[x].file,
          this.activeVariant.filesPublic[x].file.name
        )
      })
    }
    this.formData.append('existingImages', JSON.stringify(existingImageFiles))

    // this.formData.append('deletedImages', JSON.stringify(this.removedImages))
    this.formData.append('product', JSON.stringify(product))
    const variantOrder = []
    for (let index = 0; index < this.variants.length; index++) {
      const element = this.variants[index]
      if (element.date_added !== undefined) {
        variantOrder.push({ id: element.product_id, sort_order: element.sort_order })
      }
    }
    this.formData.append('variantOrder', JSON.stringify(variantOrder))
    this.upload(this.formData)
    // validate

    // this.$refs['activeVariant'].validate((valid) => {
    //   if (valid) {
    //     alert('submit!');
    //   } else {
    //       console.log('error submit!!');
    //       return false;
    //   }
    // })

    // send to php
    // this.$refs.form.$el.submit()

    // const { data } = await createProduct(product, this.formData)
    // console.log(data)
    // if (data.successful === true) {
    //   this.formData!.append("id", data.product.id);
    //   this.formData!.append("product", JSON.stringify(product));
    //   this.upload(this.formData)
    //   Message({
    //     message: 'Article would have been created',
    //     type: 'success',
    //     duration: 5 * 1000
    //   })
    // } else {
    //   Message({
    //     message: data.errors.join('\r\n'),
    //     type: 'error',
    //     duration: 7 * 1000
    //   })
    // }
  }
  /**
   * Sends the product info and images to the server.
   * images are sorted based on sort_order.
   */
  // TODO
  private async upload(formData: any) {
    // const url = `https://modellbau.3dprintit.de/admin/api/products/uploadImages.php`;
    // return axios.post(url, formData)
    // get data
    // .then(x => x.data)
    // add url field
    // .then(x => x.map(img => Object.assign({},
    //    img, { url: `${BASE_URL}/images/${img.id}` })));
    this.isUploading = true
    try {
      const { data } = await createProduct(this.formData)
      console.log(data)
      if (data && data.successful === true) {
        // const created = data.date_added
        const id: number = data.product_id
        // set created values from the DB
        //this.activeVariant!.product_id = id
        //this.activeVariant!.date_added = created
        this.meldung = 'Artikel erfolgreich erstellt.'
        this.snackbar = true
        // reload this ID
        //show correct path in browser
        // e.g. from new to product_id
        this.$router.push({ path: `/product/edit/${id}` })
        // // - get info

        const answer = await getProductForEdit(id.toString())
        this.variants = []
        this.variantsUnedited = []
        answer.data.forEach(product => {
          this.addServerProduct(product)
        })

        // set the active variant
        for (let index = 0; index < this.variants.length; index++) {
          const variant = this.variants[index]
          if (variant.product_id == id) {
            this.activeVariant = variant
            if (this.activeVariant.images.length != 0) {
              this.activeImage = this.activeVariant.images[0]
            }
            break
          }
        }
        // set stock
        this.selectedStockOption = this.activeVariant?.stock_status_id.toString()
      } else {
        this.meldung = 'Fehler bei dem Versuch den Artikel anzulegen: ' + data.errors.join('\r\n')
        this.snackbar = true
      }
      this.isUploading = false
    } catch (error) {
      console.log(error)
      this.meldung = 'Der Server ist aktuell nicht erreichbar. Fehlermeldung: ' + error
      this.snackbar = true
      this.isUploading = false
    }

    // const { data } = await uploadImages(this.formData)
  }

  /**
   * Apply changes to a product that already existed
   */
  applyProductChanges() {
    // TODO: ...
    const formValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!formValid) {
      return false
    }
    console.log('processing upload data')
    if (this.activeVariant == null) {
      throw new Error('activeVariant is not defined!')
    }
    //get changes
    const uneditedVariant: Product = this.variantsUnedited.find(variant => {
      return variant.product_id == this.activeVariant.product_id
    })

    const changedProperties: any = {}
    changedProperties.product_id = this.activeVariant.product_id
    if (this.activeVariant.price != this.activeVariant.oldPrice) {
      changedProperties.price = this.activeVariant.price
    }
    if (uneditedVariant.tax_id != this.activeVariant.tax_id) {
      changedProperties.tax_id = this.activeVariant.tax_id
    }
    if (uneditedVariant.date_available != this.activeVariant.date_available) {
      changedProperties.date_available = this.activeVariant.date_available
    }
    if (uneditedVariant.weight != this.activeVariant.weight) {
      changedProperties.weight = this.activeVariant.weight
    }
    if (uneditedVariant.width != this.activeVariant.width) {
      changedProperties.width = this.activeVariant.width
    }
    if (uneditedVariant.length != this.activeVariant.length) {
      changedProperties.length = this.activeVariant.length
    }
    if (uneditedVariant.height != this.activeVariant.height) {
      changedProperties.height = this.activeVariant.height
    }
    if (uneditedVariant.weight_class_id != this.activeVariant.weight_class_id) {
      changedProperties.weight_class_id = this.activeVariant.weight_class_id
    }
    if (uneditedVariant.length_class_id != this.activeVariant.length_class_id) {
      changedProperties.length_class_id = this.activeVariant.length_class_id
    }
    if (uneditedVariant.public != this.activeVariant.public) {
      changedProperties.public = this.activeVariant.public
    }
    if (uneditedVariant.stock_quantity != this.activeVariant.stock_quantity) {
      changedProperties.stock_quantity = this.activeVariant.stock_quantity
    }
    if (uneditedVariant.stock_status_id != this.activeVariant.stock_status_id) {
      changedProperties.stock_status_id = this.activeVariant.stock_status_id
    }
    if (uneditedVariant.category != this.activeVariant.category) {
      changedProperties.category = this.activeVariant.category
    }
    if (uneditedVariant.product_number != this.activeVariant.product_number) {
      changedProperties.product_number = this.activeVariant.product_number
    }
    if (this.activeVariant.tags.length != uneditedVariant.tags.length) {
      changedProperties.tags = this.activeVariant.tags
    } else {
      // taglength is same - check if all tags are the same
      for (let index = 0; index < this.activeVariant.tags.length; index++) {
        const activeTag = this.activeVariant.tags[index]
        const oldTag = uneditedVariant.tags[index]
        if (activeTag.name != oldTag.name) {
          changedProperties.tags = this.activeVariant.tags
          break
        }
      }
    }

    for (let index = 0; index < this.activeVariant.description.length; index++) {
      const description = this.activeVariant.description[index]
      const descriptionUnedited = uneditedVariant.description[index]
      if (
        description.name != descriptionUnedited.name ||
        description.variantname != descriptionUnedited.variantname ||
        description.description != descriptionUnedited.description ||
        description.metaTitle != descriptionUnedited.metaTitle ||
        description.metaDescription != descriptionUnedited.metaDescription ||
        description.metaKeyword != descriptionUnedited.metaKeyword ||
        description.automaticSEO != descriptionUnedited.automaticSEO
      ) {
        changedProperties.description = this.activeVariant.description
        break
      }
    }

    changedProperties.newImages = []
    const changedImages = []
    for (let index = 0; index < this.activeVariant.images.length; index++) {
      const element = this.activeVariant.images[index]
      if (element.file != null) {
        changedProperties.newImages.push(element.file)
        if (changedProperties.images == null) {
          changedProperties.images = []
        }
        changedProperties.images.push(element)
      } else {
        for (let uneditedIndex = 0; uneditedIndex < uneditedVariant.images.length; uneditedIndex++) {
          const uneditedCurrent = uneditedVariant.images[uneditedIndex]
          if (element.path == uneditedCurrent.path) {
            if (element.sort_order != uneditedCurrent.sort_order) {
              changedImages.push({
                product_image_id: element.product_image_id,
                sort_order: element.sort_order
              })
            }
            break
          }
        }
        // TODO: after adding image via image browser of existing images, send ID here
      }
    }

    console.log(changedProperties)
    // TODO: ändere product description. gib description id, und verweise von product auf product description id.
    // zweck: kein neuer description eintrag notwendig bei änderung von anderen wichtigen dingen wie bsp. preis.
    //TODO continue

    // touch up
    const product = this.touchUpUpdate(changedProperties)
    const newImageFiles: any[] = changedProperties.newImages
    const existingImageFiles: any[] = []
    this.sortImages(this.activeVariant)

    this.formData = new FormData()
    if (newImageFiles.length > 0) {
      Array.from(Array(newImageFiles.length).keys()).map(x => {
        this.formData.append('newImages', newImageFiles[x], newImageFiles[x].name)
      })
    }
    if (product.newImages.length == 0) {
      product.newImages = undefined
    }

    //publicFiles
    const publicFilesChanges = []
    for (let index = 0; index < this.activeVariant.filesPublic.length; index++) {
      const elementCurrent = this.activeVariant.filesPublic[index]
      for (let i2 = 0; i2 < uneditedVariant.filesPublic.length; i2++) {
        const elementOld = uneditedVariant.filesPublic[i2]
        if (elementCurrent.id == elementOld.id) {
          // if names don't match, send new name to server
          if (elementCurrent.name != elementOld.name) {
            publicFilesChanges.push({ id: elementCurrent.id, name: elementCurrent.name })
          }
          break
        }
      }
    }
    this.formData.append(
      'filesPublicChanges',
      JSON.stringify({ deleted: this.activeVariant.removedPublicFiles, changed: publicFilesChanges })
    )
    //new public files
    if (this.activeVariant.filesPublic.length > 0) {
      Array.from(Array(this.activeVariant.filesPublic.length).keys()).map(x => {
        if (this.activeVariant.filesPublic[x].id < 0) {
          this.formData.append(
            'filesPublic',
            this.activeVariant.filesPublic[x].file,
            this.activeVariant.filesPublic[x].file.name
          )
        }
      })
    }

    this.formData.append('changedImages', JSON.stringify(changedImages))
    this.formData.append('deletedImages', JSON.stringify(this.activeVariant.removedImages))
    this.formData.append('product', JSON.stringify(product))
    const variantOrder = []
    for (let index = 0; index < this.variants.length; index++) {
      const element = this.variants[index]
      if (element.date_added !== undefined) {
        variantOrder.push({ id: element.product_id, sort_order: element.sort_order })
      }
    }
    this.formData.append('variantOrder', JSON.stringify(variantOrder))
    this.uploadChanges(this.formData)
  }
  private async uploadChanges(formData: any) {
    this.isUploading = true
    try {
      const { data } = await updateProduct(this.formData)

      if (data && data.successful === true) {
        // const modified = data.date_modified
        // const id = data.product_id
        const id = this.activeVariant.product_id
        // set created values from the DB
        //this.activeVariant!.product_id = id
        //this.activeVariant!.date_modified = modified
        this.meldung = 'Artikel erfolgreich aktualisiert.'
        this.snackbar = true
        // reload this ID
        // - get info
        const answer = await getProductForEdit(id.toString())
        this.variants = []
        this.variantsUnedited = []
        answer.data.forEach(product => {
          this.addServerProduct(product)
        })

        // set the active variant
        for (let index = 0; index < this.variants.length; index++) {
          const variant = this.variants[index]
          if (variant.product_id == id) {
            this.activeVariant = variant
            if (this.activeVariant.images.length != 0) {
              this.activeImage = this.activeVariant.images[0]
            }
            break
          }
        }
        // set stock
        this.selectedStockOption = this.activeVariant?.stock_status_id.toString()
      } else {
        this.meldung = 'Fehler bei dem Versuch den Artikel zu aktualisieren: ' + data.errors.join('\r\n')
        this.snackbar = true
      }
      this.isUploading = false
    } catch (error) {
      console.log(error)
      this.meldung = 'Der Server ist aktuell nicht erreichbar. Fehlermeldung: ' + error
      this.snackbar = true
      this.isUploading = false
    }
  }
  onCancel() {
    //TODO
  }
  /**
   * returns true if the active variant is in the database.
   */
  get activeVariantIsCreated() {
    return this.activeVariant!.product_id >= 1
  }
  private addImagePreview(file: any) {
    const reader = new FileReader()
    // const vm = this

    reader.onload = (e: any) => {
      const im = e.target.result
      let nextSortOrderEntry = 0
      for (const image of this.activeVariant!.images) {
        if (image.sort_order >= nextSortOrderEntry) {
          nextSortOrderEntry = image.sort_order + 1
        }
      }
      const prodIm: ProductImage = {
        product_image_id: null,
        path: file.name,
        path_small: null,
        sort_order: nextSortOrderEntry,
        date_added: new Date(),
        text: [
          {
            language_id: this.language_id,
            description: '',
            name: file.name // TODO: option to rename images
          }
        ],
        previewBeforeUpload: im,
        file
      }
      this.activeVariant!.images.push(prodIm)
      if (this.activeImage == null) {
        this.activeImage = this.activeVariant!.images[0]
      }
      this.createPreviewSourceList()
    }
    reader.readAsDataURL(file)
  }
  private readFile(file: any) {
    const reader = new FileReader()
    // const vm = this

    reader.onload = (e: any) => {
      const im = e.target.result
      let nextSortOrderEntry = 0
      for (const existingFile of this.activeVariant.filesPublic) {
        if (existingFile.sort_order >= nextSortOrderEntry) {
          nextSortOrderEntry = existingFile.sort_order + 1
        }
      }
      const newFile: ShopFile = {
        id: -(nextSortOrderEntry + 1),
        name: file.name,
        extension: 'todo',
        size: file.size,
        viewed: 0,
        date_modified: null,
        sort_order: nextSortOrderEntry,
        date_added: new Date(),
        file
      }
      this.activeVariant!.filesPublic.push(newFile)
    }
    reader.readAsDataURL(file)
  }
  private createPreviewSourceList() {
    this.activeVariant!.previewSourceList = []
    for (const image of this.activeVariant!.images) {
      if (image.previewBeforeUpload != null) {
        this.activeVariant!.previewSourceList.push(image.previewBeforeUpload)
      } else {
        this.activeVariant!.previewSourceList.push(image.path)
      }
    }
  }

  addServerProduct(product: any) {
    const newProduct: Product = {
      product_id: product.product_id,
      product_number: product.product_number,
      viewed: product.viewed,
      public: product.public,
      quantity_per_lot: product.quantity_per_lot,
      price: product.price,
      oldPrice: product.price,
      tax_id: product.tax_id,
      stock_quantity: product.stock_quantity,
      stock_status_id: product.stock_status_id,
      weight_class_id: product.weight_class_id,
      length_class_id: product.length_class_id,
      date_available: product.date_available,
      date_added: product.date_added,
      date_modified: product.date_modified,
      weight: product.weight,
      length: product.length,
      width: product.width,
      height: product.height,
      description: product.product_description,
      images: [], // get set after this {} definition
      filesPublic: [], // get set after this {} definition
      tags: product.tags != null ? product.tags : [],
      digital: product.digital,
      manufacturing_price: product.manufacturing_price,
      previewSourceList: [], //for updates
      sort_order: product.sort_order,
      category: product.category,
      removedImages: [], //for updates
      removedPublicFiles: [] //for updates
    }
    // images
    product.images.forEach((image: DBProductImage) => {
      newProduct.images.push({
        path: image.path,
        text: [],
        previewBeforeUpload: null,
        product_image_id: image.product_image_id,
        path_small: image.path_small,
        sort_order: image.sort_order,
        date_added: image.date_added
      })
    })
    if (product.filesPublic != undefined) {
      product.filesPublic.forEach((file: ShopFile) => {
        newProduct.filesPublic.push({
          id: file.id,
          name: file.name,
          extension: file.name,
          size: file.size,
          sort_order: file.sort_order,
          viewed: file.viewed,
          date_added: file.date_added,
          date_modified: file.date_modified,
          path: file.path
        })
      })
    }

    this.variants.push(newProduct)
    this.variantsUnedited.push(deepCopy(newProduct))
  }

  // add an bare bones product template variant
  addProductTemplate() {
    let newProduct: Product
    if (process.env.NODE_ENV == 'dev') {
      newProduct = {
        product_id: -(this.variants.length + 1),
        viewed: 0,
        public: false,
        quantity_per_lot: 1,
        price: 99999,
        tax_id: 1,
        stock_quantity: 0,
        stock_status_id: 2,
        weight_class_id: 2,
        length_class_id: 2,
        date_available: new Date(),
        description: [
          {
            language_id: this.language_id,
            description:
              'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
            name: 'Lorem ipsumusss',
            variantname: 'Lorem',
            metaTitle: 'Lorem ipsum',
            metaDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor',
            metaKeyword: '',
            automaticSEO: true
          }
        ],
        images: [],
        filesPublic: [],
        tags: [],
        digital: false,
        previewSourceList: [],
        sort_order: this.variants.length,
        removedImages: [],
        removedPublicFiles: []
      }
    } else {
      newProduct = {
        product_id: -(this.variants.length + 1),
        viewed: 0,
        public: false,
        quantity_per_lot: 1,
        price: 0,
        tax_id: 1,
        stock_quantity: 0,
        stock_status_id: 2,
        weight_class_id: 2,
        length_class_id: 2,
        digital: false,
        date_available: new Date(),
        description: [
          {
            language_id: this.language_id,
            description: '',
            name: '',
            variantname: '',
            metaTitle: '',
            metaDescription: '',
            metaKeyword: '',
            automaticSEO: true
          }
        ],
        images: [],
        filesPublic: [],
        tags: [],
        previewSourceList: [],
        sort_order: this.variants.length,
        removedImages: [],
        removedPublicFiles: []
      }
    }
    // t['description.translated'] = () => {
    //   console.log('you reached it!')
    //   const found = t.description.find(desc => desc.language_id == this.language_id)
    //   if (found == undefined) {
    //     return t.description[0]
    //   }
    //   return found
    // }
    this.variants.push(newProduct)
  }

  // add a new variant based on an existing one
  addProductTemplateFromExisting() {
    const newProduct: Product = deepCopy(this.activeVariant)
    // TODO: replace with continous variable, since it might clash if we delete a variant
    newProduct.product_id = -this.variants.length
    newProduct.date_added = undefined
    newProduct.date_modified = undefined
    newProduct.product_number = undefined
    newProduct.sort_order = this.variants.length
    newProduct.description[0].variantname = 'Variante ' + (this.variants.length + 1).toString()
    this.variants.push(newProduct)
  }
  private draggedImageSortOrder: number | null = null
  private onDragImage(sort_order: number) {
    this.draggedImageSortOrder = sort_order
    //event.dataTransfer.setData('image_id', event.target.key)
  }
  private onDragOverImage(event: any) {
    event.preventDefault()
  }
  private onDropImage(event, sort_order: number) {
    event.preventDefault()
    const tmp = this.draggedImageSortOrder
    if (tmp != null) {
      this.activeVariant!.images.forEach(im => {
        if (im.sort_order == tmp) {
          im.sort_order = sort_order
        } else if (im.sort_order == sort_order) {
          im.sort_order = tmp
        }
      })
    }
  }
}
